export const MuiAppBar = {
    styleOverrides: {
        root: {
            boxShadow: "none"
        }
    }
};
//# sourceMappingURL=AppBar.js.map